import { TeamOption } from 'Modules/Plans/Team/hooks/useTeamSelect';
import { creatorbase } from '@round/api';
import { GenericDropdownOption } from 'App.types';
import { ValueType } from 'react-select';
import * as yup from 'yup';
import { BillingEntityOption } from 'Modules/Plans/Finance/BillingEntities/hooks/useBillingEntitySelect';

export type FormValues = Pick<creatorbase.PostPurchaseOrderData, 'request_reference' | 'description'> & {
    amount: number | undefined;
    poNumber: creatorbase.PostPurchaseOrderData['number'];
    currency: ValueType<GenericDropdownOption<number>, false>;
    billingEntity: ValueType<BillingEntityOption, false>;
    fileUpload: File | null;
    team: ValueType<TeamOption, false>;
    isInternal: boolean;
};

export const validationSchema = yup.object().shape(
    {
        poNumber: yup
            .string()
            .label('PO number')
            .when(['request_reference', 'isInternal'], {
                is: (request_reference: string, isInternal: boolean) => !request_reference && !isInternal,
                then: (schema) => schema.required('PO number or Req. reference is required'),
                otherwise: (schema) => schema,
            }),
        request_reference: yup
            .string()
            .label('Req. reference')
            .when(['poNumber', 'isInternal'], {
                is: (poNumber: string, isInternal: boolean) => !poNumber && !isInternal,
                then: (schema) => schema.required('Req. reference or PO number is required'),
                otherwise: (schema) => schema,
            }),
        amount: yup
            .number()
            .label('Amount')
            .min(0)
            .test('hasCurrency', 'Currency is required', (_, context) => {
                return !!context.parent.currency;
            }),
        billingEntity: yup.object().label('Billing Entity').required().nullable(),
        description: yup.string().label('Description').required(),
        team: yup.object().label('Team').required().nullable(),
        fileUpload: yup
            .mixed()
            .nullable()
            .when('billingEntity', {
                is: (billingEntity: ValueType<BillingEntityOption, false>) => {
                    return !!billingEntity?.requires_file_upload;
                },
                then: (schema) => schema.required('File upload is required'),
                otherwise: (schema) => schema,
            }),
    },
    [['poNumber', 'request_reference']]
);
